import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

const { color, shadows, font, mediaQuery } = baseVariables;

const alert1 = 'rgba(208, 2, 27, 0.1)';
const editIndicator = 'rgb(6, 102, 197)';

export const StyledPropertyCard = styled.div<{ hasError: boolean }>`
  .reslink-property-card-header {
    background-color: ${({ hasError }) => (hasError ? alert1 : color.neutral20)};
    column-gap: ${toRem(6)};
    .transparent-icon {
      background: transparent;
      &:focus-visible {
        outline: -webkit-focus-ring-color auto ${toRem(1)};
      }
    }
    .icon-disabled {
      color: ${color.neutral30};
    }
    .seperator {
      border: ${toRem(1)} solid ${color.neutral30};
    }
    .remove-hotel {
      flex-basis: 100%;
      @media ${mediaQuery.md} {
        flex-basis: unset;
      }
    }
  }

  .reslink-property-card {
    box-shadow: ${shadows.boxShadowTile} 0 ${toRem(4)} ${toRem(20)} 0;
    .property-card {
      border-radius: 0;
      box-shadow: none;
      .carousel-image {
        border-radius: 0 !important;
      }
    }

    .room-details-summary {
      position: relative;
      border-top: ${toRem(1)} solid ${color.neutral30};
      .room-rates-summary {
        .edit-link {
          color: ${color.bvyAccent20};
          background: transparent;
          text-decoration: underline;
          .edit-label {
            display: none;
          }
          .icon-edit {
            font-size: ${font.fontL};
            font-weight: ${font.fontWeightMedium};
          }
          &:hover,
          &:focus {
            .edit-label {
              display: inline;
              color: ${color.bvyAccent20};
            }
            .icon-edit {
              display: none;
            }
          }
        }
      }
      .edit-indicator {
        position: absolute;
        right: 0;
        width: ${toRem(8)};
        height: ${toRem(42)};
        background: ${editIndicator};
      }
    }
  }
`;
